import { useQuery } from '@tanstack/react-query';
import { fetchAggregationData } from '../macro.routes';

export const AGGREGATION_QUERY_KEY = ['macro-aggregation'] as const;

export function useAggregationQuery() {
  return useQuery({
    queryKey: AGGREGATION_QUERY_KEY,
    queryFn: fetchAggregationData,
    staleTime: 60 * 60 * 1000,
  });
}
